import type { FC } from "react";
import React from "react";

import type { WelcomeOfferBannerItems } from "~/core";
import { Markdown, StripeWrapper, useUiKitComponents } from "~/shared/ui-kit";
import { Title } from "~/shared/ui-kit/title/Title";

export type WelcomeOfferCardsProps = {
  card: WelcomeOfferBannerItems;
  className?: string;
  href?: string;
  onPress: () => void;
};

export const WelcomeOfferCard: FC<WelcomeOfferCardsProps> = ({
  card,
  className,
  href,
  onPress,
}) => {
  const { Link } = useUiKitComponents();

  const cardContent = (
    <StripeWrapper
      variant="quaternary"
      className={`flex flex-col min-w-fit !w-[148px] min-h-[148px] md:min-h-[150px] md:min-w-[295px] px-[5px] md:px-[10px] justify-center rounded-2xl !bg-[position:inherit] ${className}`}
    >
      <Title
        as="h4"
        size="large"
        md={{ size: "medium" }}
        weight="bold"
        className="bg-sunrise bg-clip-text text-transparent text-center"
      >
        {card.title}
      </Title>
      {card.description && <Markdown>{card.description}</Markdown>}
    </StripeWrapper>
  );

  if (!href) {
    return <div onClick={onPress}>{cardContent}</div>;
  }

  return <Link href={href}>{cardContent}</Link>;
};
